import { PageReturns } from './Overview';
import { PageReturnsView } from './View';

export const RETURNS = {
  Returns: PageReturns,
  ReturnsView: PageReturnsView,
} as const;
